import type { WorkspacePlaybookStatus } from '@doneverse/shared'

export interface KanbanColumnDef {
  id: string
  title: string
  dotColor: string
  statuses: WorkspacePlaybookStatus[]
}

const sharedColumns: KanbanColumnDef[] = [
  { id: 'progress', title: 'BRIEFED / UNDERWAY', statuses: ['briefed'], dotColor: '#f59e0b' },
  { id: 'revisions', title: 'REVISIONS UNDERWAY', statuses: ['in_revision'], dotColor: '#0D25FF' },
  { id: 'done', title: 'DONE', statuses: ['completed'], dotColor: '#22c55e' },
]

export const founderColumns: KanbanColumnDef[] = [
  { id: 'todo', title: 'TO BE BRIEFED', statuses: ['to_be_briefed'], dotColor: '#ef4444' },
  ...sharedColumns,
]

export const doerColumns: KanbanColumnDef[] = [
  { id: 'awaiting', title: 'AWAITING BRIEF', statuses: ['to_be_briefed'], dotColor: '#ef4444' },
  ...sharedColumns,
]

export const teamColumns = [
  { id: 'todo', title: 'TO DO', dotColor: '#ef4444' },
  { id: 'progress', title: 'IN PROGRESS', dotColor: '#f59e0b' },
  { id: 'done', title: 'DONE', dotColor: '#22c55e' },
]
